import { FC } from "react";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import RectangularSkeleton from "@shared/components/skeleton/RectangleSkeleton";

interface Props {
  hasAddToCart?: boolean;
}

export const CourseCardSkeleton: FC<Props> = ({ hasAddToCart }) => {
  const isMobile = useIsMobile();

  return hasAddToCart ? (
    <div className="rounded-8 border bg-fds-primary border-fds-cart hover:shadow-brand-md sm:p-3 flex flex-col p-3 h-full gap-4">
      <div className="w-full aspect-video mb-2">
        <RectangularSkeleton width="100%" />
      </div>
      <div className="h-12 sm:mb-1.5 flex flex-col justify-between">
        <RectangularSkeleton width="100%" height={isMobile ? 16 : 18} />
        <RectangularSkeleton width={40} height={isMobile ? 14 : 18} />
      </div>
      <div className="h-6">
        <RectangularSkeleton width={120} height={isMobile ? 16 : 14} />
      </div>
      <div className="flex w-full py-2 justify-between items-center">
        <RectangularSkeleton width={62} height={16} />
        <RectangularSkeleton className="rounded-full" width={24} height={24} />
      </div>
    </div>
  ) : (
    <div className="rounded-8 border bg-fds-primary border-fds-cart hover:shadow-brand-md sm:p-3 flex flex-col p-3 h-full">
      <div className="w-full aspect-video mb-2">
        <RectangularSkeleton width="100%" />
      </div>
      <div className="h-10 sm:h-12 mb-1 sm:mb-1.5 flex flex-col justify-between">
        <RectangularSkeleton width="100%" height={isMobile ? 16 : 18} />
        <RectangularSkeleton width={40} height={isMobile ? 14 : 18} />
      </div>

      <div className="mt-1 ">
        <RectangularSkeleton width={120} height={isMobile ? 16 : 20} />
        <RectangularSkeleton
          className="mt-0.5"
          width={120}
          height={isMobile ? 16 : 20}
        />
      </div>
      <div className="h-7 sm:h-14 flex items-center justify-between">
        <RectangularSkeleton width={140} height={isMobile ? 14 : 20} />
        <RectangularSkeleton width={40} height={isMobile ? 14 : 20} />
      </div>
    </div>
  );
};
